import { useAuthMethods } from '@store/auth'

export const Authenticate = (): boolean => {
  const { credentials } = useAuthMethods()

  return !!credentials?.accessToken
}
